export const USER_APPLICATION_STATUS = {
  NO_APPLICATION: "no_application",
  IN_REVIEW: "in_review",
  WAITLISTED: "waitlisted",
  ACCEPTED: "accepted",
} as const;
